import { render } from "./Milkfarm.vue?vue&type=template&id=2bd6e9a4&scoped=true&bindings={}"
import script from "./Milkfarm.vue?vue&type=script&lang=ts"
export * from "./Milkfarm.vue?vue&type=script&lang=ts"

import "./Milkfarm.vue?vue&type=style&index=0&lang=scss"
import "./Milkfarm.vue?vue&type=style&index=1&id=2bd6e9a4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2bd6e9a4"

export default script